<script>
export default {
	name: 'BaseButton',

	functional: true,

	props: {
		tag: {
			type: String,
			default: undefined,
		},
	},

	render(h, ctx) {
		const { props, scopedSlots } = ctx;
		const {
			staticClass = '',
			class: dynamicClass = null,
			staticStyle = '',
			style: dynamicStyle = null,
			attrs = {},
			domProps,
			on = {},
			nativeOn,
		} = ctx.data;

		const bindings = {
			class: ['c-base-button', staticClass, dynamicClass].filter(Boolean),
			style: [staticStyle, dynamicStyle].filter(Boolean),
			attrs: {
				...attrs,
			},
			domProps,
			on,
			nativeOn,
		};

		if (attrs['aria-disabled']?.toLowerCase?.() === 'true') {
			if (on?.click) {
				bindings.on.click = (e) => {
					e.preventDefault();
				};
			}
			if (nativeOn?.click) {
				bindings.nativeOn.click = (e) => {
					e.preventDefault();
				};
			}
		}

		const tag = props.tag
			? props.tag
			: bindings.attrs.to
			? 'NuxtLinkExt'
			: 'button';
		if (tag === 'button' && !bindings.attrs.type) {
			bindings.attrs.type = 'button';
		}

		return (
			<tag {...bindings}>
				{scopedSlots.default?.() || scopedSlots.default}
			</tag>
		);
	},
};
</script>

<style lang="postcss">
.c-base-button {
	@apply inline-flex items-center justify-center px-24 py-14 rounded-25;
	@apply text-body leading-1.2;
	@apply bg-theme hover:bg-theme-90 text-white;
	@apply transition-colors duration-200 ease-in-out;
}
.c-base-button[aria-disabled='true' i] {
	@apply opacity-30 pointer-events-none;
}
</style>
